<template>
  <!-- 签约方案 -->
  <div class="ContractPlan">
    <el-row>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <span>方案名称:</span>
          <el-select placeholder="请选择方案" v-model="planName" clearable @change="seleValue">
            <el-option v-for="(item, index) in planNames" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple-light"> <el-button type="primary" @click="addPlan" class="btns" size="small" icon="el-icon-plus">添加方案</el-button></div>
      </el-col>
    </el-row>
    <el-table :data="tableData" border style="width: 95%;margin: 20px auto;">
      <el-table-column label="方案名称" prop="planName" width="150px">
      </el-table-column>
      <el-table-column>
        <template slot-scope="{row}">
          <el-table :data="row.planList" border style="width: 100%">
            <el-table-column prop="classNum" label="课节数"></el-table-column>
            <el-table-column prop="classPrice" label="课时单价"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editCol(scope.row.id)">编辑</el-button>
          <el-button type="text" size="small" @click="delCol(scope.row.id)">删除</el-button>
          <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="isShowDialog ? '添加方案' : '编辑方案'" :visible.sync="dialogVisible" :close-on-click-modal = false>
      <el-form label-width="100px">
        <el-form-item label="方案名称:">
          <el-input v-model="addObj.planName" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
          <el-button icon="el-icon-remove-outline" @click="removeItem"></el-button>
        </el-form-item>
        <el-form-item style="text-align: left;" v-for="(item, index) in addObj.planList" :key="index"
          :label="'第' + (index + 1) + '期'">
          <el-input @focus="clickInp(index)" v-model="item.classNum" size="small" style="width: 80%;"
            placeholder="请输入课节数"></el-input>
          <el-input size="small" style="width: 80%;" v-model="item.classPrice" placeholder="请输入课时单价"></el-input>
          <el-dialog :visible.sync="isShow" width="370px" append-to-body>
            <el-input style="width: 100px;" v-model="num"></el-input>---
            <el-input style="width: 100px;" v-model="num1"></el-input>
            <span class="text" @click="clickText">{{ text }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isShow = false">取 消</el-button>
              <el-button type="primary" @click="determine(index)">确 定</el-button>
            </span>
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click='determinePlan'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看详情" :visible.sync="viewDialog">
      <el-form>
        <el-form-item style="text-align: left;">
          <span>方案名称:{{ this.viewObj.planName }}</span>
        </el-form-item>
        <el-form-item style="text-align: left;" v-for="(item, index) in this.viewObj.planList" :key="index">
          <span>课时数:{{ item.classNum }}</span>
          <span style="margin-left: 50px;">课时单价:{{ item.classPrice }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">取 消</el-button>
        <el-button type="primary" @click="viewDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      isShowDialog: true,
      viewDialog: false,
      text: '+∞',
      num: "0",
      num1: "0",
      //添加方案
      addObj: {
        planName: "",
        planList: [],
      },
      viewObj: {
        planName: "",
        planList: [],
      },
      index: '',
      isShow: false,
      dialogVisible: false,
      total: 0,
      planName: '',
      planNames: [],//所有方案名称
      tableData: [],//table表格
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
    }
  },
  created () {
    this.getPlanName()
    this.getListData()
  },
  methods: {
    //删除
    delCol (id) {
      // 二次确认
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios
        .get(`${apiBaseUrl}/contract/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.getListData()
            this.getPlanName()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
      })
    },
    //搜索
    seleValue () {
      let obj = {
        planName: this.planName,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/contract/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          console.log(res.data.data, 'res.data.data')
          this.tableData = res.data.data.records
          this.requestParameters.pageNum = res.data.data.current
          this.requestParameters.pageSize = res.data.data.size
          this.total = res.data.data.total

        })
        .catch(error => {
          console.error(error);
        });
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getListData(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getListData();
    },
    //获取table表数据
    getListData () {
      let obj = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/contract/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
           console.log(res.data.data, 'res.data.data')
          this.tableData = res.data.data.records
          this.requestParameters.pageNum = res.data.data.current
          this.requestParameters.pageSize = res.data.data.size
          this.total = res.data.data.total
        })
        .catch(error => {
          console.error(error);
        });
    },
    //获取所有方案名
    getPlanName () {
      axios
        .get(`${apiBaseUrl}/contract/getPlanName`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.planNames = res.data.data
        })
        .catch(error => {
          console.error(error);
        });
    },
    //点击添加方案按钮
    addPlan () {
      this.isShowDialog = true
      this.addObj = {
        planName: "",
        planList: [],
      }
      this.dialogVisible = true
    },
    //编辑
    editCol (id) {
      this.isShowDialog = false
      this.dialogVisible = true
      axios
        .get(`${apiBaseUrl}/contract/getDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.addObj = res.data.data
        })
        .catch(error => {
          console.error(error);
        });
    },
    addInput () {
      this.addObj.planList.push({
        classNum: "",
        classPrice: ''
      });
    },
    //减少输入框
    removeItem () {
      // if (this.addList.length > 1) {
      this.addObj.planList.pop();
      // } else {
      //   this.addList.splice(0, this.addList.length);
      // }
    },
    //点击课节数input框
    clickInp (index) {
      this.index = index
      this.isShow = true
    },
    //确定
    determine () {
      this.addObj.planList[this.index].classNum = this.num + '---' + this.num1
      this.isShow = false
    },
    clickText () {
      this.num1 = this.text
    },
    //添加方案保存还是编辑方案保存
    determinePlan () {
      if (this.isShowDialog == true) {
        axios
          .post(`${apiBaseUrl}/contract/add`, this.addObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(res => {
            if (res.data.code == 200) {
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.getListData()
              this.getPlanName()
            } else {
              this.dialogVisible = false
              this.$message.error(res.data.message)
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/contract/update`, this.addObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(res => {
            if (res.data.code == 200) {
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.getListData()
              this.getPlanName()
            } else {
              this.dialogVisible = false
              this.$message.error(res.data.message)
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    //查看详情
    handleClick (id) {
      this.viewDialog = true
      axios
        .get(`${apiBaseUrl}/contract/getDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.viewObj = res.data.data
          console.log(this.viewObj);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
}
</script>

<style scoped>
.text {
  display: inline-block;
  font-size: 22px;
  border: 1px solid #ccc;
  width: 50px;
  height: 38px;
  border-radius: 5px;
}

@media screen and (max-width: 750px) {
  .ContractPlan {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  .ContractPlan>>>.el-dialog {
    width: 100% !important;
  }

  /* .ContractPlan>.el-dialog>>>.el-dialog {
    width: 100% !important;
  } */
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/ContractPlan.vue